import React from 'react';
import { connect } from 'react-redux';
import { NumberInputButtons } from '@ff-os/shared-react/components/input/number-input/NumberInputButtons';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectQuantityById } from '../../../_redux-photos';

const _PhotoPrintQuantity = ({ className, quantity, setQuantity }: Props) => {

    const min = 1;
    const max = 99999;

    return (
        <NumberInputButtons
            className={className}
            min={min} max={max}
            commit={setQuantity} value={quantity} />
    );
};

type OwnProps = {
    photoId: string;
    className?: string;
};

type Props = OwnProps & {
    quantity: number;
    setQuantity: (quantity: number) => void;
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    quantity: selectQuantityById(state, ownProps.photoId)
});

const mapDispatchToProps = (dispatch: PhotoPrintsPdpDispatch, ownProps: OwnProps) => ({
    setQuantity: (quantity: number) => dispatch(photoActions.setQuantity({
        photoId: ownProps.photoId,
        quantity: quantity
    }))
});

export const PhotoPrintQuantity = connect(
    mapStateToProps,
    mapDispatchToProps
)(_PhotoPrintQuantity);